import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { TrainingProjectSessionModel } from '../../models';
import './TrainingProjectSessionLogsList.less';

interface Props {
    session: TrainingProjectSessionModel;
    autoScroll: boolean;
    setAutoScroll: (autoScroll: boolean) => void;
}

const TrainingProjectSessionLogsList: React.FC<Props> = ({ session, autoScroll, setAutoScroll }) => {
    const ref = React.useRef<HTMLDivElement>(null);

    // Disable auto scroll when user scrolls
    React.useEffect(() => {
        const container = ref.current;

        if (!container) {
            return;
        }

        const handleWheelOrTouch = () => setAutoScroll(false);

        container.addEventListener('wheel', handleWheelOrTouch, { passive: true });
        container.addEventListener('touchmove', handleWheelOrTouch, { passive: true });

        return () => {
            container.removeEventListener('wheel', handleWheelOrTouch);
            container.removeEventListener('touchmove', handleWheelOrTouch);
        };
    }, [setAutoScroll]);

    React.useEffect(() => {
        const container = ref.current;

        if (!container || !autoScroll) {
            return;
        }

        const timeout = setTimeout(() => {
            container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
        }, 50);

        return () => clearTimeout(timeout);
    }, [session, session.logsToDisplay.length, autoScroll]);

    React.useEffect(() => {
        if (session.isCompleted) {
            session.setLogsSource('stored');
            session.loadLogs();
        }
    }, [session]);

    return (
        <div ref={ref} className="training-project-session-logs-list">
            {session.isLoadingLogs ? (
                <div className="log-line">Loading...</div>
            ) : (
                session.logsToDisplay.map((line, idx) => (
                    <div key={idx} className="log-line">
                        {line}
                    </div>
                ))
            )}
        </div>
    );
};

export default observer(TrainingProjectSessionLogsList);
